module.exports = "a.btn.btn-primary {\r\n    margin: 20px;\r\n}\r\nh2 {\r\n    color: #de0c87;\r\n}"